import { createFileRoute, Outlet } from "@tanstack/react-router";

import { PageTitle } from "~/components/ui/page-title";
import { CoachWhatsNewHereLink } from "~/components/whats-new/whats-new-here-link";

export const Route = createFileRoute("/_user/settings")({
  staticData: { title: "Settings" },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="space-y-8">
      <div className="flex items-baseline justify-between gap-4">
        <PageTitle>Settings</PageTitle>
        <CoachWhatsNewHereLink module="account" />
      </div>
      <Outlet />
    </div>
  );
}
